import { apiReq } from "./apiReq";

export const graphqlReq = async <T = unknown>(
	path: string,
	options: { query: string; variables: object; suppressError: boolean }
): Promise<{ data: T }> => {
	const { query, variables, suppressError } = options;
	const { data } = await apiReq<T>("POST", path, { query, variables }, { pathPrefix: "", suppressError });
	return data as { data: T };
};
